import { useSessionChecker } from '@btime/react-session'
import { COLORS } from '@btime/constants'
import React from 'react'

import PdfBasicOptionsForm from '../../../../components/pdf/options/PdfBasicOptionsForm'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'
import CheckboxListItem from '../../../../components/list/CheckboxListItem'
import { Title } from '../../../../components/presentation/Text'
import Separator from '../../../../components/helpers/Separator'
import Sticky from '../../../../components/helpers/Sticky'
import HeaderImage from './headerImage/HeaderImage'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'

const CustomOptionsForm = () => {
  const form = usePdfOptionsForm()
  const [isLogged] = useSessionChecker()
  const { handleChange } = usePdfOptionsFormActions()

  return (
    <>
      <CheckboxListItem
        selected={form.showQuestionInfo}
        onSelect={handleChange('showQuestionInfo')}
        label="Mostrar informações das perguntas"
        invert
      />
      {isLogged && (
        <CheckboxListItem
          selected={form.hideConfidentialInfo}
          onSelect={handleChange('hideConfidentialInfo')}
          label="Ocultar informações confidenciais"
          invert
        />
      )}
      <CheckboxListItem
        selected={form.hideChildrenServiceOrders}
        onSelect={handleChange('hideChildrenServiceOrders')}
        label="Ocultar atividades filhas"
        invert
      />
      <HeaderImage />
    </>
  )
}

const OptionsForm = () => {
  return (
    <Sticky>
      <SeparatorWrapper weight={4} usePadding>
        <Title size="h5" color={COLORS.dark3}>
          Configurações da impressão
        </Title>
      </SeparatorWrapper>

      <PdfBasicOptionsForm />
      <CustomOptionsForm />
      <Separator weight={4} />
    </Sticky>
  )
}

export default OptionsForm
